import { AlertLabel } from "../GetDirectionAndFare/models/getFareSamplesParams";

/** 予約情報参照APIから取得したレスポンスのインターフェース。 */
export interface ReservationResponse {
  /** 搭乗便の情報。 */
  flight: Flight;
  /** 出発地名称。 */
  originLabel: string;
  /** 出発地座標。 */
  originLatLng: string;
  /** 到着地名称。 */
  destLabel: string;
  /** 到着地座標。 */
  destLatLng: string;
  /** 搭乗日。 */
  date: string;
  /** 連携タクシー会社名コード。 */
  companyCode: string;
  /** 連携タクシー会社名。 */
  companyName: string;
  /** 出発便検索、または到着便検索を表す値。 */
  operation: string;
  /** お迎え日時（yyyyMMddHHmm形式）。 */
  rideDatetime: string;
  /** のりかえ情報（距離・所要時間・料金）。 */
  transferInfo: TransferInfo;
  /** 利用空港の情報。 */
  airportInfo: AirportInfo;
  /** 遷移元リファラー情報 */
  referrer: string;
  /** 庄内乗合タクシーにおいて連携される搭乗タクシーに対応するフライト情報 */
  taxiConnectFlightNumber: string;
}

/** 搭乗便の情報。 */
interface Flight {
  /** ANAまたはNHから始まる便番号。 */
  number: string;
  /** yyyyMMddHHmm形式の搭乗便の日時。 */
  datetime: string;
  /** datetimeが空港発の日時かを表すフラグ。 */
  isDeparture: boolean;
}

/** のりかえ情報（距離・所要時間・料金）。 */
interface TransferInfo {
  /** 発着地と空港の距離（単位:[m]）。 */
  distance: number,
  /** 発着地と空港間の所要時間（単位:[分]）。 */
  timeRequired: number,
  /** タリフが固定か */
  tariffConfirmed: boolean;
  /** タリフが変動する際に紐づくKey */
  tariffTypes: string;
  /** 料金情報。 */
  fare?: ReservationFare;
  /** ラベル情報 */
  labels?: ReservationLabels,
  /** タリフ情報 */
  tariffs?: {
    [key: string]: {
      /** 料金情報。 */
      fare: ReservationFare,
      /** ラベル情報 */
      labels: ReservationLabels
    }
  }
}

/** ラベル情報 */
export interface ReservationLabels {
  /** 料金ラベル */
  fareLabel: string,
  /** 距離ラベル */
  distanceLabel: string,
  /** 所要時間ラベル */
  durationLabel: string,
  /** アラートラベル */
  alertLabel: AlertLabel[],
}

/** 料金情報。 */
export interface ReservationFare {
  fareType: string,
  /** 金額（単位:[円]）。 */
  value: number,
  /** 運賃の種別。 */
  priceType: "fixed" | "ask" | "outOfService" | "PAYG" | "error",
  /** 迎車料金の有無. true時のみ存在. 省略時はfalse. */
  hasPickupFee?: boolean,
  /** 迎車料金. hasPickupFee=trueのときのみ存在。 */
  pickupFee?: number,
  /** 迎車料金が必要な条件情報。 */
  pickupFeeRequirement?: string,
  /** 付加情報。 */
  additionalInfo?: string;
  /** 備考ラベル */
  notesLabel: string[]
}

/** 利用空港の情報。 */
interface AirportInfo {
  type: 'destination' | 'origin',
  letter: string,
}

export const defaultReservationLabels: ReservationLabels = {
  fareLabel: '',
  distanceLabel: '',
  durationLabel: '',
  alertLabel: []
}

export const defaultReservationFare: ReservationFare = {
  fareType: '',
  /** 金額（単位:[円]）。 */
  value: 0,
  /** 運賃の種別。 */
  priceType: "error",
  /** 備考ラベル */
  notesLabel: []
}